/* Kylea - mega menu a colonne (desktop). Si aggancia all'apertura nativa di desktop-navigation. */
(() => {
  const ITEMS = '.mega-menu__col1-item, .mega-menu__tile-item, .mega-menu__colors-cta';
  const reduceMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const animateItems = (items, base) => {
    if (!items.length || reduceMotion() || typeof Element.prototype.animate !== 'function') return;
    items.forEach((item, i) => {
      item.getAnimations().forEach((a) => a.cancel());
      const anim = item.animate(
        { opacity: [0, 1], transform: ['translateX(-40px)', 'translateX(0)'] },
        { duration: 300, delay: base + 120 * i - Math.min(2 * i * i, 120 * i), easing: 'cubic-bezier(0.25, 1, 0.5, 1)', fill: 'both' }
      );
      anim.onfinish = () => anim.cancel();
    });
  };

  const panelsOf = (col) => (col ? Array.from(col.querySelectorAll(':scope > [data-parent]')) : []);
  const visiblePanel = (col) => panelsOf(col).find((p) => !p.hidden);
  const itemsOf = (el) => (el ? Array.from(el.querySelectorAll(ITEMS)) : []);

  const clearActive = (scope) => {
    if (!scope) return;
    scope.querySelectorAll('.is-active').forEach((li) => {
      li.classList.remove('is-active');
      const a = li.querySelector('[aria-expanded]');
      if (a) a.setAttribute('aria-expanded', 'false');
    });
  };

  const showPanel = (col, target, base) => {
    let shown = null;
    panelsOf(col).forEach((p) => {
      const match = p.dataset.parent === target;
      p.hidden = !match;
      if (match) shown = p;
    });
    if (shown) animateItems(itemsOf(shown), base);
  };

  const hideAll = (col) => panelsOf(col).forEach((p) => { p.hidden = true; });

  const setup = (root) => {
    if (root.kyExplorerReady) return;
    root.kyExplorerReady = true;
    const colTwo = root.querySelector('.mega-menu__col--two');
    const colThree = root.querySelector('.mega-menu__col--three');

    root.addEventListener('click', (event) => {
      const link = event.target.closest('[data-ky-x-toggle]');
      if (!link || !root.contains(link)) return;
      const li = link.parentElement;
      if (li.classList.contains('is-active')) return; // secondo clic: apre la pagina

      event.preventDefault();
      Array.from(li.parentElement.children).forEach((sib) => {
        if (sib === li) return;
        sib.classList.remove('is-active');
        const a = sib.querySelector('[aria-expanded]');
        if (a) a.setAttribute('aria-expanded', 'false');
      });
      li.classList.add('is-active');
      link.setAttribute('aria-expanded', 'true');

      const target = link.dataset.kyXTarget;
      if (link.dataset.kyXToggle === '2') {
        showPanel(colTwo, target, 80);
        clearActive(colTwo);
        hideAll(colThree);
      } else {
        showPanel(colThree, target, 80);
      }
    });
  };

  const onOpen = (event) => {
    const megaMenu = event.target && event.target.currentMegaMenu;
    if (!megaMenu) return;
    const root = megaMenu.querySelector('[data-ky-explorer]');
    if (!root) return;
    setup(root);
    animateItems(itemsOf(root.querySelector('.mega-menu__col--one')), 140);
    animateItems(itemsOf(visiblePanel(root.querySelector('.mega-menu__col--two'))), 220);
    animateItems(itemsOf(visiblePanel(root.querySelector('.mega-menu__col--three'))), 300);
  };

  document.addEventListener('desktop-nav:dropdown:open', onOpen);

  // Menu mobile: fisarmonica categorie → prodotti → colori
  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-ky-mx-toggle]');
    if (!toggle) return;
    const panel = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!panel) return;
    event.preventDefault();
    const isOpen = toggle.getAttribute('aria-expanded') === 'true';
    const item = toggle.closest('[data-ky-mx-item]');
    toggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
    panel.hidden = isOpen;
    if (item) item.classList.toggle('is-open', !isOpen);
    if (!isOpen) animateItems(Array.from(panel.children), 80);
  });
  const init = () => document.querySelectorAll('[data-ky-explorer]').forEach(setup);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
